import { pgSelect, isSupabaseConfigured } from './supabaseClient';
import { getLang } from '../i18n';
import type { POI } from '../types';

/**
 * POI content translations (written by the content agent into
 * poi_translations). Loaded once per language; displayPoi() overlays the
 * translated name/description for DISPLAY ONLY — the base (English) fields
 * on the POI object are never mutated, so Dashboard edits and ids stay safe.
 */

let cache = new Map<string, { name?: string; description?: string }>();
let cachedLang = '';

export async function loadPoiTranslations(): Promise<void> {
  const lang = getLang();
  if (lang === cachedLang) return;
  if (lang === 'en' || !isSupabaseConfigured()) {
    cache = new Map();
    cachedLang = lang;
    return;
  }
  try {
    const rows = await pgSelect<{ poi_id: string; name: string | null; description: string | null }>(
      'poi_translations',
      `select=poi_id,name,description&lang=eq.${encodeURIComponent(lang)}`,
    );
    cache = new Map(
      rows.map((r) => [r.poi_id, { name: r.name ?? undefined, description: r.description ?? undefined }]),
    );
    cachedLang = lang;
  } catch {
    /* offline — keep whatever we had */
  }
}

/** Display name/description for the CURRENT language (base as fallback). */
export function displayPoi(poi: POI): { name: string; description?: string } {
  const t = cache.get(poi.id);
  return { name: t?.name ?? poi.name, description: t?.description ?? poi.description };
}
